import styled from 'styled-components'
import {
  Container as Grid,
  BottomNavigation,
  tokens
} from '@arvoreeducacao/bonsai-ds'

const { colors, sizes, fontWeights } = tokens

export const Container = styled.div`
  width: 100%;
  height: 72px;
  background: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${tokens.shadows.shadowTop1};

  @media (max-width: ${sizes.mdScreen}px) {
    display: none;
  }
`

export const ContainerGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FooterCopyright = styled.p`
  font-size: ${sizes.bodySmall}px;
  color: ${colors.black5};
`

export const ContainerButtonFooter = styled.div`
  display: flex;
`

export const ButtonFooter = styled.a`
  padding: 0 ${sizes.padding}px;
  height: 40px;
  border-radius: ${tokens.radius.large};
  margin-right: ${tokens.spacing.horizontalMedium};
  background: ${colors.white};
  border: 1px solid ${colors.black2};
  color: ${colors.black5};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in;
  font-weight: ${fontWeights.semiBold};
  text-decoration: none;
  &:hover {
    border: 1px solid ${colors.black3};
    color: ${colors.dark6};
  }

  &:last-child {
    margin-right: 0;
  }
`

export const StyledBottomNavigation = styled(BottomNavigation)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
